import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../services/store";
import { AxiosError } from "axios";
import { patchPostConfirmation } from "src/shared/services/src";
import { EyengageActions } from "src/shared/redux-state/src/lib/eyengage/EyengageSlice";
import { ChildrenStoreData } from "src/shared/types/src";
import { getCurrentChild, GlobalErrorActions } from "src/shared/redux-state/src";
import { GoCheckCircleFill } from "react-icons/go";
import { CustomButton } from "src/app/components";
import { toast } from "react-toastify";


export default function ConfirmPostComponent({ confirmationStatus, confirmedAt, postId } : { confirmationStatus: boolean, confirmedAt: string, postId: string }) {
    const dispatch = useAppDispatch();

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    const [isConfirming, setConfirming] = useState<boolean>(false);
    const [confirmStatus, setConfirmStatus] = useState<boolean>(confirmationStatus);
    const [confirmedAtLocal, setConfirmedAt] = useState<string>(confirmedAt);

    useEffect(() => {
        setConfirmStatus(confirmationStatus);
        setConfirmedAt(confirmedAt);
    }, [confirmationStatus, confirmedAt]);

    const handleConfirmAction = async () => {
        if (isConfirming)
            return;
        
        try {
            setConfirming(true);
            const response = await patchPostConfirmation({ child: currentChild, postId });
            if (response && Object.keys(response).length) {
                const { confirmedAt, confirmedByMe } = response.post;
                setConfirmStatus(confirmedByMe);
                await dispatch(EyengageActions.updateConfirmPostDataInPostById({ postId, updatedConfirmByMe: confirmedByMe, confirmedAt }));
            } else {
                setConfirmStatus(false);
            }
        } catch (error) {
            console.log("error in confirm api : ", error);
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                if (apiError && apiError.response && apiError.response.status === 404) {
                    const { errors } = error.response?.data;
                    await dispatch(GlobalErrorActions.setError({ isError: true, message: errors.length > 0 ? errors.join(',') : errors.join(", ") }));
                    toast.error(errors.join(", "), { autoClose: 5000 })
                }
            }
            setConfirmStatus(false);
        } finally {
            setConfirming(false);
        }
    }

    return (
        <>
            {
                confirmStatus ?
                <div className="mg-t-15">
                    <div className="d-flex align-items-center">
                        <div className="text-success"><GoCheckCircleFill size={15} /></div>
                        <p className="fs-12 text-black mg-b-0 mg-l-7">{ confirmedAtLocal ? `Confirmed on ${confirmedAtLocal}` : '' }</p>
                    </div>
                </div> : 
                <>
                    <div className="mg-t-15">
                        <div className="d-flex align-items-center">
                            <p className="fs-12 text-black mg-b-0 flex-grow-1">This post requires confirmation.</p>
                            <CustomButton 
                                text="Confirm" 
                                onClick={handleConfirmAction} 
                                color="outline-success"
                                customBtnStyle={'text-black w-auto mg-l-10 btn-I-confirm'}
                                isLoading={isConfirming}
                            />
                        </div>
                    </div>
                </>
            }
        </>
    )
}